import React from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { useTranslation } from "react-i18next"

const Logo = ({ className, heightClassName = "h-12" }) => {
  const { i18n } = useTranslation()

  return (
    <Link
      className={`block ${className}`}
      link={`/${i18n.language}`}
      isCrossWebsiteLink={true}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 285.446 166.582"
        className={`inline-block ${heightClassName}`}
      >
        <path
          fill="#E60004"
          d="M110.409 92.605c.053 2.653 2.206 4.527 5.224 4.527 3.548 0 5.255-2.331 5.255-4.691V54.747h20.573v38.694c-.327 14.627-10.478 18.773-26.577 19.1-15.063-.653-25.377-3.653-25.706-19.1V54.747h21.23v37.858zm41.64-37.857v55.775h20.574V89.948l9.822 20.575h24.394l-17.246-27.724 17.836-28.052h-24.194l-10.743 19.411v-19.41h-20.443zm81.534 57.792c-19.406 0-28.586-9.507-28.586-29.349s9.266-29.333 28.912-29.333c18.326 0 27.41 9.49 27.41 29.448 0 19.842-8.688 29.234-27.736 29.234zm-.445-40.971c-3.3 0-6.548 1.348-7.934 5.351-.572 1.64-.51 3.726-.51 6.348 0 2.376-.064 4.417.503 6.177 1.059 3.3 3.62 5.399 7.982 5.399 4.284 0 6.745-2.26 7.747-5.301.626-1.901.48-4.108.48-6.263 0-2.74.011-4.889-.475-6.367-.981-2.983-3.416-5.344-7.793-5.344zM83.163 110.524H59.764L48.959 92.895v17.629H27.567V54.747l38.123-.001c9.15 0 16.568 7.417 16.568 16.568 0 8.273-6.064 15.128-13.99 16.367l14.895 22.843zM55.162 81.271a5.738 5.738 0 1 0 0-11.478l-6.202.018v11.461h6.202z"
        />
        <path
          fill="#E60004"
          d="M0 83.296 142.737.009l142.724 83.287-142.724 83.296L0 83.296zm7.146 0L142.737 162.4 278.32 83.296 142.737 4.156 7.146 83.296z"
        />
      </svg>
    </Link>
  )
}

export default Logo
